export default "__VITE_ASSET__DthhIY89__"